<template>
    <div class="category mb-5">
        <Breadcrumb :breadcrumb="breadcrumb"/>
        <Shoplist
            :brands="metadata.brands"
            :categories="metadata.product_categories"
            :variations="metadata.variations"
            :products="products"
            :title="page_title"
            :total="total"
            :limit="products_limit"
        />
    </div>
</template>

<script>
    import Breadcrumb from '~/components/Breadcrumb';
    import utils from "~/mixins/utils";
    import fb_pixel_event from "~/mixins/fb_pixel_event";
    import lgpd_verification from "~/mixins/lgpd_verification";
    import Shoplist from "~/components/Shoplist";

    export default {
        mixins: [
            utils,
            fb_pixel_event,
            lgpd_verification
        ],
        components: {
            Shoplist,
            Breadcrumb,
        },
        head() {
            return {
                title: this.page_title
            }
        },
        mounted() {
            this.fbqEvent('track', 'Search', {search_string: this.$route.query.q})
            if (this.LgpdResponseAnalytics()) {
                this.gtagEvent('event', 'search', {search_term: this.$route.query.q})
            }
        },
        computed: {
            breadcrumb() {
                return [
                    {
                        name: 'Página inicial',
                        link: '/'
                    },
                    {
                        name: this.page_title,
                        link: null
                    }
                ];
            },
            page_title() {
                if (this.$route.query.q) {
                    return `Busca por "${this.$route.query.q}"`
                }
                if (this.$route.query.filter_brands) {
                    return `Resultado por marcas`
                }
                return 'Produtos'
            },
            products_limit() {
                return this.$route.query.limit || 12
            },
        },
        watchQuery: ['page', 'sort', 'sort_field', 'sort_value', 'limit', 'brand_code', 'filter_brands', 'filter_categories', 'filter_variations'],
        async asyncData({params, query, res, $axios, req, app, error}) {
            const products_limit = query.limit || 12;
            let products_query = `?p=ecommerce_buscas_api_v1&page=${query.page}&limit=${products_limit}&show_attributes=true&show_brands=yes&show_variations=yes&show_product_categories=yes&&filter_brands=${params.filter_brands}&thumb=sim&x=340&show_payments=true`;
            if (query.q) {
                products_query += `&q=${encodeURIComponent(query.q)}`
            }
            if (query.sort === 'name' || query.sort === '-name') {
                products_query += `&sort[]=${query.sort}`
            } else if (query.sort === 'price' || query.sort === '-price') {
                products_query += `&sort[]=-active`
                products_query += `&sort[]=${query.sort}`
                products_query += `&sort[]=-relevance`
            } else {
                products_query += `&sort[]=-active`
                products_query += `&sort[]=-relevance`
            }
            if (query.filter_brands) {
                try {
                    const filter_brands = JSON.parse(query.filter_brands)
                    filter_brands.forEach(el => {
                        products_query += `&filter_brands[]=` + el
                    })
                } catch (e) {
                    console.log(e)
                }
            }
            if (query.filter_variations) {
                try {
                    const filter_variations = JSON.parse(query.filter_variations)
                    filter_variations.forEach(el => {
                        products_query += `&filter_variations[]=` + el
                    })
                } catch (e) {
                    console.log(e)
                }
            }
            if (query.filter_categories) {
                try {
                    const filter_categories = JSON.parse(query.filter_categories)
                    filter_categories.forEach(el => {
                        products_query += `&filter_categories[]=` + el
                    })
                } catch (e) {
                    console.log(e)
                }
            }
            try {
                const products = await $axios.$get(products_query);
                return {
                    metadata: products.metadata,
                    products: products.data,
                    total: products.total_items
                }
            } catch (e) {
                console.error(e)
            }
        }
    }
</script>
